<div class="spinner-container-history-table">
    <mat-spinner class="content-box"></mat-spinner>
</div>